/**
 * The strings that belong to looking at a photograph (FIL-8a).
 *
 * The frame's own controls and the three states of fetching bytes moved to
 * `Viewer/viewer.copy.ts` when FIL-8b's reader needed the same words. What is
 * left is stepping between images, which is this viewer's alone — a document
 * counts pages instead.
 *
 * Sentence case, no emoji, and the file's own name wherever a control could
 * otherwise be one of several identical ones — a screen reader hearing
 * "Download" three times on a page has been told nothing.
 */
export const IMAGE_VIEWER_COPY = {
  previous: 'Previous image',
  next: 'Next image',
  position: (current: number, total: number) => `${String(current)} of ${String(total)}`,
} as const;
